/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AktivitetTypeWithVejledning } from '../models/aktivitet-type-with-vejledning';
import { ProjektSted } from '../models/projekt-sted';
import { AktivitetTypeReference } from '../models/aktivitet-type-reference';
import { GuidePunktHierarki } from '../models/guide-punkt-hierarki';
import { GuidePunktReference } from '../models/guide-punkt-reference';
@Injectable({
  providedIn: 'root',
})
class AktiviteterService extends __BaseService {
static readonly getAllPath = '/aktiviteter';
static readonly getAktivitetLangVejledningPath = '/aktiviteter/aktivitetlangvejledning';
static readonly getGuidedHierarchyPath = '/aktiviteter/guidedhierarchy';
static readonly getGuidePunktTypeLangVejledningPath = '/aktiviteter/guidepunktlangvejledning';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param sted undefined
   * @return Success
   */
  private getAllResponse(sted?: ProjektSted): __Observable<__StrictHttpResponse<Array<AktivitetTypeWithVejledning>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = sted;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/aktiviteter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AktivitetTypeWithVejledning>>;
      })
    );
  }

  /**
   * @param sted undefined
   * @return Success
   */
  getAll(sted?: ProjektSted): __Observable<Array<AktivitetTypeWithVejledning>> {
    return this.getAllResponse(sted).pipe(
      __map(_r => _r.body as Array<AktivitetTypeWithVejledning>)
    );
  }

  /**
   * @param typeReference undefined
   * @return Success
   */
  private getAktivitetLangVejledningResponse(typeReference?: AktivitetTypeReference): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = typeReference;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/aktiviteter/aktivitetlangvejledning`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }

  /**
   * @param typeReference undefined
   * @return Success
   */
  getAktivitetLangVejledning(typeReference?: AktivitetTypeReference): __Observable<string> {
    return this.getAktivitetLangVejledningResponse(typeReference).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param sted undefined
   * @return Success
   */
  private getGuidedHierarchyResponse(sted?: ProjektSted): __Observable<__StrictHttpResponse<GuidePunktHierarki>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = sted;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/aktiviteter/guidedhierarchy`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GuidePunktHierarki>;
      })
    );
  }

  /**
   * @param sted undefined
   * @return Success
   */
  getGuidedHierarchy(sted?: ProjektSted): __Observable<GuidePunktHierarki> {
    return this.getGuidedHierarchyResponse(sted).pipe(
      __map(_r => _r.body as GuidePunktHierarki)
    );
  }

  /**
   * @param typeReference undefined
   * @return Success
   */
  private getGuidePunktTypeLangVejledningResponse(typeReference?: GuidePunktReference): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = typeReference;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/aktiviteter/guidepunktlangvejledning`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }

  /**
   * @param typeReference undefined
   * @return Success
   */
  getGuidePunktTypeLangVejledning(typeReference?: GuidePunktReference): __Observable<string> {
    return this.getGuidePunktTypeLangVejledningResponse(typeReference).pipe(
      __map(_r => _r.body as string)
    );
  }
}

module AktiviteterService {
}

export { AktiviteterService }
